import * as React from 'react';
import { SecondStepHeader } from './Header/Header';
import { connect } from 'react-redux';
import PlusPackage from '../../../components/PlusPackage/PlusPackage';
import DetailsPanel from './DetailsPanel/DetailsPanel';
import PricePanel from '../../../components/PricePanel/PricePanel';
import { getText } from '../../../../services/text/text-service';
import {
    HalvCoveragesNames,
    HelCoveragesNames,
    TrafikCoveragesNames
} from '../../../../types/enums/products/companyCar/coverages';
import { Coverage } from '../../../../types/Coverage';
import {
    halvPriceSelector,
    helPriceSelector,
    plusPackagePriceSelector,
    tillagsAllriskPriceSelector,
    tillagsHyrbilPriceSelector,
    trafikPriceSelector
} from '../../../../selectors/companyCar/secondStepSelectors';
import { resolveCarInsurance } from '../../../../services/calculation-data/calculation-data-service';
import { isIPad13, isMobile, isTablet } from 'react-device-detect';
import { CalculationOut } from '../../../../types/calculationData/products/companyCar/calculationOut';
import uuid from 'uuid';
import {
    createUtagViewData,
    invokeUtagData
} from '../../../../utils/statisticsUtils';
import { resolveTillagsPrice } from '../../../../services/summary-page/companyCar';
import { StatsDataEnum } from '../../../../types/enums/statsDataEnum';
import { resolvePartnerForStats } from '../../../../services/stats/stats-service';
import AdditionalCoveragesPanel from '../../../components/AdditionalCoveragesPanel/AdditionalCoveragesPanel';
import ExpandedCards from '../../../components/ExpandedCard/ExpandedCards';
import ExpandedCard from '../../../components/ExpandedCard/ExpandedCard';
import BuyingInformationPanel from '../../../components/BuyingInformationPanel/BuyingInformationPanel';
import ProductsNumbers from '../../../../types/enums/productsNumbers';

interface SecondStepProps {
    onSubmit: any;
    insuranceSelectionHandling: Function;
    plusPackageBuyHandling: Function;
    plusPackageSelected: boolean;
    tillagsBuyHandling: Function;
    tillagsSelected: boolean;
    tillagsHyrbilSelected: boolean;
    tillagsAllriskSelected: boolean;
    carDamageChangeHandling: Function;
    mileageChangeHandling: Function;
    paymentTermChangeHandling: Function;
    driverUnder24Handling: Function;
    setPricesForSummaryPage: Function;
    mailingChannelChangeHandling: Function;
    goBack: Function;
}

interface State {
    isError: boolean;
    trafikCardSelected: boolean;
    halvCardSelected: boolean;
    helCardSelected: boolean;
    chosenInsuranceName: string;
}

interface StateToProps {
    firstCalculationData: any;
    trafikPrice: any;
    halvPrice: any;
    helPrice: any;
    plusPackagePrice: number;
    tillagsAllriskPrice: number;
    tillagsHyrbilPrice: number;
}
class SecondStep extends React.Component<
    SecondStepProps & StateToProps,
    State
> {
    resolveRecommendationInsuranceCard = (
        insuranceName: string,
        insuranceRemark: boolean,
        calculationOut: CalculationOut
    ) => {
        if (
            (calculationOut.directInport === 'IMPORT' ||
                calculationOut.directInport === 'TULL') &&
            calculationOut.vehicleAge < 3
        ) {
            return insuranceName === 'Hel';
        } else return insuranceRemark;
    };

    state = {
        isError: false,
        trafikCardSelected: this.resolveRecommendationInsuranceCard(
            'Trafik',
            this.props.firstCalculationData.calculatedData.calculationOut
                .trafikRemark,
            this.props.firstCalculationData.calculatedData.calculationOut
        ),
        halvCardSelected: this.resolveRecommendationInsuranceCard(
            'Halv',
            this.props.firstCalculationData.calculatedData.calculationOut
                .halvRemark,
            this.props.firstCalculationData.calculatedData.calculationOut
        ),
        helCardSelected: this.resolveRecommendationInsuranceCard(
            'Hel',
            this.props.firstCalculationData.calculatedData.calculationOut
                .helRemark,
            this.props.firstCalculationData.calculatedData.calculationOut
        ),
        chosenInsuranceName: resolveCarInsurance(
            this.props.firstCalculationData.calculatedData.calculationOut
                .trafikRemark,
            this.props.firstCalculationData.calculatedData.calculationOut
                .halvRemark
        )
    };

    componentDidMount() {
        if (isMobile) {
            window.scrollTo(0, 0);
        }
        window.sessionStorage.removeItem('companyCarOrgNo');
        window.sessionStorage.removeItem('regPlate');
    }

    interval = setInterval(() => {
        //@ts-ignore
        if (window.utag) {
            invokeUtagData(
                createUtagViewData(
                    StatsDataEnum.APPLICATION_NAME,
                    'company-car',
                    resolvePartnerForStats(),
                    window.location.pathname +
                        'tjanstebilforsakring/' +
                        StatsDataEnum.OFFER,
                    StatsDataEnum.PAGE_TITLE,
                    'tjanstebilforsakring',
                    StatsDataEnum.OFFER
                )
            );
            clearInterval(this.interval);
        }
    }, 500);

    resolveChosenInsurancePrice = (): number => {
        if (this.state.trafikCardSelected) {
            return this.props.trafikPrice;
        } else if (this.state.halvCardSelected) {
            return this.props.halvPrice;
        } else return this.props.helPrice;
    };

    handleCardSelect = selectedCardValue => {
        if (
            selectedCardValue ===
            getText(
                'webshopsweden.products.companyCar.insurance.trafikInsurance'
            )
        ) {
            this.setState({
                trafikCardSelected: true,
                chosenInsuranceName: getText(
                    'webshopsweden.products.companyCar.insurance.trafikInsurance'
                ),
                halvCardSelected: false,
                helCardSelected: false
            });
            this.props.insuranceSelectionHandling(0, this.props.trafikPrice);
        } else if (
            selectedCardValue ===
            getText('webshopsweden.products.companyCar.insurance.halvInsurance')
        ) {
            this.setState({
                trafikCardSelected: false,
                halvCardSelected: true,
                chosenInsuranceName: getText(
                    'webshopsweden.products.companyCar.insurance.halvInsurance'
                ),
                helCardSelected: false
            });
            this.props.insuranceSelectionHandling(1, this.props.halvPrice);
        } else if (
            selectedCardValue ===
            getText('webshopsweden.products.companyCar.insurance.helInsurance')
        ) {
            this.setState({
                trafikCardSelected: false,
                halvCardSelected: false,
                helCardSelected: true,
                chosenInsuranceName: getText(
                    'webshopsweden.products.companyCar.insurance.helInsurance'
                )
            });
            this.props.insuranceSelectionHandling(2, this.props.helPrice);
        }
    };

    resolveRecommendationText = (
        carType: number,
        carAge: number,
        remark: boolean,
        directImport: string
    ): string => {
        if (remark) {
            if (carType === 1) {
                if (carAge < 3) {
                    if (directImport === 'IMPORT') {
                        return getText(
                            'webshopsweden.products.companyCar.insurance.helInsurance.recommendationText.personalCarImport'
                        );
                    }
                    return getText(
                        'webshopsweden.products.companyCar.insurance.halvInsurance.recommendationText.personalCarUnder3'
                    );
                } else if (carAge >= 3 && carAge < 17) {
                    return getText(
                        'webshopsweden.products.companyCar.insurance.helInsurance.recommendationText.personalCar'
                    );
                } else
                    return getText(
                        'webshopsweden.products.companyCar.insurance.halvInsurance.recommendationText.personalCarOver17'
                    );
            } else {
                if (carAge < 3) {
                    return getText(
                        'webshopsweden.products.companyCar.insurance.halvInsurance.recommendationText.lightTruckUnder3'
                    );
                } else if (carAge >= 3 && carAge < 17) {
                    return getText(
                        'webshopsweden.products.companyCar.insurance.helInsurance.recommendationText.lightTruck'
                    );
                } else
                    return getText(
                        'webshopsweden.products.companyCar.insurance.halvInsurance.recommendationText.lightTruckOver17'
                    );
            }
        } else return '';
    };

    resolveInsuranceData = () => {
        if (this.state.chosenInsuranceName === 'Trafikförsäkring') {
            return this.trafikInsuranceData;
        } else if (this.state.chosenInsuranceName === 'Halvförsäkring') {
            return this.halvInsuranceData;
        } else return this.helInsuranceData;
    };

    trafikInsuranceData = {
        name: getText(
            'webshopsweden.products.companyCar.insurance.trafikInsurance'
        ),
        mobileCardName: getText(
            'webshopsweden.products.companyCar.insurance.trafikInsurance.mobileCardName'
        ),
        availableCoverages: TrafikCoveragesNames
    };

    halvInsuranceData = {
        name: getText(
            'webshopsweden.products.companyCar.insurance.halvInsurance'
        ),
        mobileCardName: getText(
            'webshopsweden.products.companyCar.insurance.halvInsurance.mobileCardName'
        ),
        availableCoverages: HalvCoveragesNames
    };

    helInsuranceData = {
        name: getText(
            'webshopsweden.products.companyCar.insurance.helInsurance'
        ),
        mobileCardName: getText(
            'webshopsweden.products.companyCar.insurance.helInsurance.mobileCardName'
        ),
        availableCoverages: HelCoveragesNames
    };

    trafikCoverage: Coverage = {
        coverageName: getText(
            'webshopsweden.products.companyCar.coverage.trafik'
        ),
        coverageDescription: getText(
            'webshopsweden.products.companyCar.coverage.trafikDescription'
        )
    };

    fireGlassTheftCoverage: Coverage = {
        coverageName: getText(
            'webshopsweden.products.companyCar.coverage.fireGlassTheft'
        ),
        coverageDescription: getText(
            'webshopsweden.products.companyCar.coverage.fireGlassTheftDescription'
        )
    };

    rescueCoverage: Coverage = {
        coverageName: getText(
            'webshopsweden.products.companyCar.coverage.rescue'
        ),
        coverageDescription: getText(
            'webshopsweden.products.companyCar.coverage.rescueDescription'
        )
    };

    legalCoverage: Coverage = {
        coverageName: getText(
            'webshopsweden.products.companyCar.coverage.legal'
        ),
        coverageDescription: getText(
            'webshopsweden.products.companyCar.coverage.legalDescription'
        )
    };

    damageCoverage: Coverage = {
        coverageName: getText(
            'webshopsweden.products.companyCar.coverage.damage'
        ),
        coverageDescription: getText(
            'webshopsweden.products.companyCar.coverage.damageDescription'
        )
    };

    assistansCoverage: Coverage = {
        coverageName: getText(
            'webshopsweden.products.companyCar.coverage.assistans'
        ),
        coverageDescription: getText(
            'webshopsweden.products.companyCar.coverage.assistansDescription'
        )
    };

    carAccidentCoverage: Coverage = {
        coverageName: getText(
            'webshopsweden.products.companyCar.coverage.carAccident'
        ),
        coverageDescription: getText(
            'webshopsweden.products.companyCar.coverage.carAccidentDescription'
        )
    };

    pluspaketAllriskCoverage: Coverage = {
        coverageName: getText(
            'webshopsweden.products.companyCar.coverage.allRisk'
        ),
        coverageDescription: getText(
            'webshopsweden.products.companyCar.coverage.allRiskDescription'
        )
    };

    companyCarCoverages = [
        this.trafikCoverage,
        this.fireGlassTheftCoverage,
        this.rescueCoverage,
        this.legalCoverage,
        this.damageCoverage
    ];

    render() {
        let tillagsAllriskCoverage: Coverage = {
            coverageName: getText(
                'webshopsweden.products.companyCar.coverage.allRisk'
            ),
            coverageDescription: getText(
                'webshopsweden.products.companyCar.coverage.additionalAllRiskDescription'
            ),
            coverageId: 817,
            selected: this.props.firstCalculationData.calculatedData.calculation
                .tillagsAllriskCoverage,
            price: this.props.tillagsAllriskPrice
        };

        let tillagsHyrbilCoverage: Coverage = {
            coverageName: getText(
                'webshopsweden.products.companyCar.coverage.hyrbil'
            ),
            coverageDescription: getText(
                'webshopsweden.products.companyCar.coverage.hyrbilDescription'
            ),
            coverageId: 281,
            selected: this.props.firstCalculationData.calculatedData.calculation
                .tillagsHyrbilCoverage,
            price: this.props.tillagsHyrbilPrice
        };

        let plusPackageCoverages = [
            tillagsHyrbilCoverage,
            this.carAccidentCoverage,
            this.pluspaketAllriskCoverage,
            this.assistansCoverage
        ];

        let tillagsCoverages = [tillagsHyrbilCoverage, tillagsAllriskCoverage];

        return (
            <div className="row">
                <SecondStepHeader
                    customerName={
                        this.props.firstCalculationData.calculatedData
                            .calculationOut.customerName
                    }
                    carData={
                        this.props.firstCalculationData.calculatedData
                            .calculationOut.vehicleName +
                        ' - ' +
                        this.props.firstCalculationData.calculatedData
                            .calculation.regPlate
                    }
                />
                <ExpandedCards
                    allCoveragesList={this.companyCarCoverages}
                    insuranceData={this.resolveInsuranceData()}
                    chosenInsuranceName={this.state.chosenInsuranceName}>
                    {!(isMobile || isTablet || isIPad13) && (
                        <div className="col-xs-1-5" />
                    )}
                    <ExpandedCard
                        insuranceData={this.trafikInsuranceData}
                        isOpen={this.state.trafikCardSelected}
                        handleClick={() =>
                            this.handleCardSelect(
                                getText(
                                    'webshopsweden.products.companyCar.insurance.trafikInsurance'
                                )
                            )
                        }
                        price={this.props.trafikPrice}
                        allCoveragesList={this.companyCarCoverages}
                        paymentTerm={
                            this.props.firstCalculationData.calculatedData
                                .calculation.paymentTerm
                        }
                        recommended={this.resolveRecommendationInsuranceCard(
                            'Trafik',
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.trafikRemark,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut
                        )}
                        recommendationText={this.resolveRecommendationText(
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.vehicleType,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.vehicleAge,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.trafikRemark,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.directInport
                        )}
                    />
                    <div
                        className={
                            isMobile || isTablet || isIPad13
                                ? 'mobile-expandable-card-gap'
                                : 'col-xs-1'
                        }
                    />
                    <ExpandedCard
                        insuranceData={this.halvInsuranceData}
                        isOpen={this.state.halvCardSelected}
                        handleClick={() =>
                            this.handleCardSelect(
                                getText(
                                    'webshopsweden.products.companyCar.insurance.halvInsurance'
                                )
                            )
                        }
                        price={this.props.halvPrice}
                        allCoveragesList={this.companyCarCoverages}
                        paymentTerm={
                            this.props.firstCalculationData.calculatedData
                                .calculation.paymentTerm
                        }
                        recommended={this.resolveRecommendationInsuranceCard(
                            'Halv',
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.halvRemark,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut
                        )}
                        recommendationText={this.resolveRecommendationText(
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.vehicleType,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.vehicleAge,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.halvRemark,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.directInport
                        )}
                    />
                    <div
                        className={
                            isMobile || isTablet || isIPad13
                                ? 'mobile-expandable-card-gap'
                                : 'col-xs-1'
                        }
                    />
                    <ExpandedCard
                        insuranceData={this.helInsuranceData}
                        isOpen={this.state.helCardSelected}
                        handleClick={() =>
                            this.handleCardSelect(
                                getText(
                                    'webshopsweden.products.companyCar.insurance.helInsurance'
                                )
                            )
                        }
                        price={this.props.helPrice}
                        allCoveragesList={this.companyCarCoverages}
                        paymentTerm={
                            this.props.firstCalculationData.calculatedData
                                .calculation.paymentTerm
                        }
                        recommended={this.resolveRecommendationInsuranceCard(
                            'Hel',
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.helRemark,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut
                        )}
                        recommendationText={this.resolveRecommendationText(
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.vehicleType,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.vehicleAge,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.helRemark,
                            this.props.firstCalculationData.calculatedData
                                .calculationOut.directInport
                        )}
                    />
                    {!(isMobile || isTablet || isIPad13) && (
                        <div className="col-xs-1-5" />
                    )}
                </ExpandedCards>

                {!(
                    this.state.trafikCardSelected || this.props.tillagsSelected
                ) && (
                    <PlusPackage
                        handlePlusPackageBuy={this.props.plusPackageBuyHandling}
                        price={this.props.plusPackagePrice}
                        paymentTerm={
                            this.props.firstCalculationData.calculatedData
                                .calculation.paymentTerm
                        }
                        coverages={plusPackageCoverages}
                        selectedInsuranceName={this.state.chosenInsuranceName}
                        plusPackageBought={
                            this.props.firstCalculationData.calculatedData
                                .calculation.pluspaketCoverages
                        }
                    />
                )}

                {!(
                    this.state.trafikCardSelected ||
                    this.props.plusPackageSelected
                ) && (
                    <AdditionalCoveragesPanel
                        handleTillagsBuy={this.props.tillagsBuyHandling}
                        price={resolveTillagsPrice(
                            this.props.tillagsAllriskSelected,
                            this.props.tillagsAllriskPrice,
                            this.props.tillagsHyrbilSelected,
                            this.props.tillagsHyrbilPrice
                        )}
                        paymentTerm={
                            this.props.firstCalculationData.calculatedData
                                .calculation.paymentTerm
                        }
                        coverages={tillagsCoverages}
                        tillagsBought={
                            this.props.firstCalculationData.calculatedData
                                .calculation.tillagsCoverages
                        }
                        disableButton={
                            !(
                                this.props.tillagsAllriskSelected ||
                                this.props.tillagsHyrbilSelected
                            )
                        }
                        showPrice={
                            this.props.tillagsAllriskSelected ||
                            this.props.tillagsHyrbilSelected
                        }
                    />
                )}
                <DetailsPanel
                    mileageChangeHandling={this.props.mileageChangeHandling}
                />
                <BuyingInformationPanel
                    paymentTermChangeHandling={
                        this.props.paymentTermChangeHandling
                    }
                    onSubmit={this.props.onSubmit}
                    setPricesForSummaryPage={this.props.setPricesForSummaryPage}
                    chosenPrice={this.resolveChosenInsurancePrice()}
                    plusPackagePrice={this.props.plusPackagePrice}
                    mailingChannelChangeHandling={
                        this.props.mailingChannelChangeHandling
                    }
                    goBack={this.props.goBack}
                    tillagsPrice={resolveTillagsPrice(
                        this.props.tillagsAllriskSelected,
                        this.props.tillagsAllriskPrice,
                        this.props.tillagsHyrbilSelected,
                        this.props.tillagsHyrbilPrice
                    )}
                    hideMailingChannel={true}
                    showContactHelp={true}
                    productNumber={ProductsNumbers.COMPANY_CAR}
                />
                <PricePanel
                    insuranceName={this.state.chosenInsuranceName}
                    paymentTerm={
                        this.props.firstCalculationData.calculatedData
                            .calculation.paymentTerm
                    }
                    insurancePrice={this.resolveChosenInsurancePrice()}
                    plusPackageAdded={
                        this.props.firstCalculationData.calculatedData
                            .calculation.pluspaketCoverages
                    }
                    plusPackagePrice={this.props.plusPackagePrice}
                    tillagsAdded={
                        this.props.firstCalculationData.calculatedData
                            .calculation.tillagsCoverages
                    }
                    tillagsHyrbilAdded={
                        this.props.firstCalculationData.calculatedData
                            .calculation.tillagsHyrbilCoverage
                    }
                    tillagsHyrbilPrice={this.props.tillagsHyrbilPrice}
                    tillagsAllriskAdded={
                        this.props.firstCalculationData.calculatedData
                            .calculation.tillagsAllriskCoverage
                    }
                    tillagsAllriskPrice={this.props.tillagsAllriskPrice}
                    key={uuid.v4()}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    firstCalculationData: state.calculationData,
    trafikPrice: trafikPriceSelector(state),
    halvPrice: halvPriceSelector(state),
    helPrice: helPriceSelector(state),
    plusPackagePrice: plusPackagePriceSelector(state),
    tillagsHyrbilPrice: tillagsHyrbilPriceSelector(state),
    tillagsAllriskPrice: tillagsAllriskPriceSelector(state)
});

export default connect<{}, {}, any>(mapStateToProps)(SecondStep);
